<mat-card appearance="outlined">
  <mat-card-content>

    <div class="page-title-row">
      <h2>{{ 'billing.guide-claims.title' | translate }}</h2>
      <mat-form-field>
        <mat-label>{{ 'billing.guide-claims.filters.guide-participant' | translate }}</mat-label>
        <mat-select [(value)]="selectedParticipant">
          @for (participant of participants; track participant) {
          <mat-option [value]="participant">{{participant.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="inline-filters">

      <mat-form-field>
        <mat-label>{{ 'billing.guide-claims.filters.service-date-from' | translate }}:</mat-label>
        <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="filters.serviceDateFrom!">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateFromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'billing.guide-claims.filters.service-date-to' | translate }}:</mat-label>
        <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="filters.serviceDateTo!">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateToPicker></mat-datepicker>
      </mat-form-field>

      <button matButton="tonal" (click)="applyFilters()">{{ 'billing.guide-claims.filters.apply-filters' | translate }}</button>

    </div>


    <div class="mode-toggle">
      <mat-stepper labelPosition="bottom" #stepper (selectionChange)="onStepChanged($event)">
        <mat-step>
          <ng-template matStepLabel>{{ 'billing.guide-claims.modes.invoices' | translate }}</ng-template>

          <mat-card appearance="outlined">
            <mat-card-content>
              <app-datatable-component #invoiceTable [data]="invoiceData()" [columns]="invoiceColumns"></app-datatable-component>
            </mat-card-content>
            <mat-card-actions align="start">
              <button matButton="filled" (click)="generateInvoice()" [disabled]="this.invoiceSelection.isEmpty()">{{ 'billing.guide-claims.buttons.generate-invoice' | translate }}</button>
              <button matButton="filled" (click)="clearSelection()" [disabled]="this.invoiceSelection.isEmpty()">{{ 'billing.guide-claims.buttons.clear-selection' | translate }}</button>
            </mat-card-actions>
          </mat-card>

        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{ 'billing.guide-claims.modes.received' | translate }}</ng-template>

          <mat-card appearance="outlined">
            <mat-card-content>
              <app-datatable-component #receivedTable [data]="receivedData()" [columns]="receivedColumns"></app-datatable-component>
            </mat-card-content>
            <mat-card-actions align="start">
              <button matButton="filled" (click)="receiveInvoices()" [disabled]="this.receivedSelection.isEmpty()">{{ 'billing.guide-claims.buttons.receive-payment' | translate }}</button>             
              <button matButton="filled" (click)="clearSelection()" [disabled]="this.receivedSelection.isEmpty()">{{ 'billing.guide-claims.buttons.clear-selection' | translate }}</button>
            </mat-card-actions>
          </mat-card>

        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{ 'billing.guide-claims.modes.remitted' | translate }}</ng-template>
          <mat-card appearance="outlined">
            <mat-card-content>
              <app-datatable-component #remitedTable [data]="remitedData()" [columns]="remittedColumns"></app-datatable-component>
            </mat-card-content>
            <mat-card-actions align="start">
              <button matButton="filled" (click)="remitInvoices()" [disabled]="this.remitSelection.isEmpty()">{{ 'billing.guide-claims.buttons.remit' | translate }}</button>
              <button matButton="filled" (click)="clearSelection()" [disabled]="this.remitSelection.isEmpty()">{{ 'billing.guide-claims.buttons.clear-selection' | translate }}</button>
            </mat-card-actions>
          </mat-card>
        </mat-step>
      </mat-stepper>

    </div>


  </mat-card-content>
</mat-card>


